import React, { ReactElement, useEffect, useState } from 'react';
import useIsMobile from '../../../../hooks/useIsMobile';
import { useTimer } from '../../../../contexts/timerContext';
import { formatTime } from '../../../../utils/string';
import { COLOR_BLUE } from '../../../../constants/constants';
import { t } from 'i18next';

const TimerBox = (): ReactElement => {
	const { timeLeft, isRunning } = useTimer();

	const [isMobile, setIsMobile] = useState(false);
	useEffect((): (() => void) => useIsMobile(setIsMobile), []);

	const TIMER_EXPIRING: number = 300;

	return isRunning ? (
		<div className='timer-box'>
			<h3 className='text-center' style={{ width: '100%' }}>
				{t('common.time-remaining')}&nbsp;&nbsp;
				<span
					style={{
						width: '100%',
						color: timeLeft < TIMER_EXPIRING ? 'red' : COLOR_BLUE,
						fontSize: '2.5rem',
					}}>
					<strong>{formatTime(timeLeft)}</strong>
				</span>
			</h3>
		</div>
	) : (
		<></>
	);
};

export default TimerBox;